import type { Filter } from '../../types/filter.types';
import { isAnd, isExpr } from './filter-utils';

export function* iterateFilter(root: Filter): Generator<Filter> {
  function* walk(node: Filter): Generator<Filter> {
    yield node;
    if (isExpr(node)) {
      return;
    }

    const op = isAnd(node) ? 'and' : 'or';
    const children: Filter[] = (node as any)[op]?.operands ?? [];
    yield* walkList(children);
  }

  function* walkList(items: Filter[]): Generator<Filter> {
    if (items.length === 0) {
      return;
    }
    const [head, ...tail] = items;
    yield* walk(head);
    yield* walkList(tail);
  }

  yield* walk(root);
}
